export enum PageNames {
  HOMEPAGE = 'homepage',
  DETAIL_PAGE_INTRO = 'productDetailIntro',
  DETAIL_PAGE_OFFER = 'productDetailOffer',
  DETAIL_PAGE_ENTERTAINMENT = 'productDetailEntertainment',
  DETAIL_PAGE_ORDER_OPTIONS = 'productDetailOrderOptions',
  DETAIL_PAGE_INFO = 'productDetailInfo',
  ARROW_DIRECTION = 'arrow_direction',
  PINCODE_MODAL = 'input_pincode_modal',
  CONDITIONS_MODAL = 'input_conditions_modal',
  FAQS_MODAL = 'input_faqs_modal',
  TERMS_AND_CONDITIONS_MODAL = 'input_tc_modal',
  ORDERING_SUCCEEDED = 'ordering_succeeded_modal',
  ORDERING_FAILED = 'ordering_failed_modal',
  ORDERING_MESSAGE = 'ordering-message-modal',
  DEEP_LINKING = 'deepLinkingPage',
  MAINTENANCE_PAGE = 'maintenancePage',
  TRIAL_MODAL_MANAGER = 'trialModalManager',
  TRIAL_CODE_MODAL = 'trialCodeModal',
  TRIAL_COMPARISON_MODAL = 'trialComparisonModal',
  TRIALS_PAGE = 'trialsPage',
  FIND_TRIAL_CODE_MODAL = 'findTrialCodeModal',
  TRIAL_SUCCESS_MODAL = 'trailSuccessModal',
  TRIAL_ACTIVATION_PENDING = 'trialActivationPendingModal',
  TRIAL_ATTEMPTS_REACHED = 'trialAttemptsReached',
  PLAY_SPORTS_PAGE = 'playSportsPage',
  STREAMING_BUNDLE_OPTION = 'streamingBundleOption',
  STANDALONE_FLAVORS = 'standaloneFlavors',
  PACK_OPTION_SELECTION = 'packOptionSelection'
}
